import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5el0lb07s2llnhdb50g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('تم الاشتراك بنجاح!');
        setEmail('');
      } else {
        setSubmitMessage('حدث خطأ، يرجى المحاولة مرة أخرى');
      }
    } catch (error) {
      setSubmitMessage('حدث خطأ، يرجى المحاولة مرة أخرى');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 3000);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#0A0E27] via-[#0F1535] to-[#0A0E27] border-t border-[#00D9FF]/20 relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,217,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,217,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px] pointer-events-none"></div>
      
      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-2 h-2 bg-[#00D9FF] rounded-full"></span>
              طيبات الطبية العالمية
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              تجارة طبية دولية مع استثمار تشغيلي شفاف. نوفر فرص استثمارية موثوقة في قطاع الأجهزة الطبية والمستلزمات الطبية.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-2 h-2 bg-[#00FF94] rounded-full"></span>
              تواصل معنا
            </h4>
            <div className="space-y-3 text-sm">
              <p className="text-gray-400 flex items-center gap-2 hover:text-[#00D9FF] transition-colors">
                <i className="ri-map-pin-line text-[#00D9FF]"></i>
                الرياض، المملكة العربية السعودية
              </p>
              <p className="text-gray-400 flex items-center gap-2 hover:text-[#00D9FF] transition-colors">
                <i className="ri-mail-line text-[#00D9FF]"></i>
                info@tayyibat-medical.com
              </p>
              <p className="text-gray-400 flex items-center gap-2 hover:text-[#00D9FF] transition-colors">
                <i className="ri-phone-line text-[#00D9FF]"></i>
                +966 XX XXX XXXX
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-2 h-2 bg-[#00FF94] rounded-full"></span>
              اشترك في النشرة الإخبارية
            </h4>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form id="newsletter_form" className="space-y-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="البريد الإلكتروني"
                className="w-full px-4 py-2.5 bg-[#131829] border border-[#00D9FF]/20 rounded-lg text-white text-sm focus:outline-none focus:border-[#00D9FF] transition-colors placeholder:text-gray-500"
                required
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-4 py-2.5 bg-gradient-to-r from-[#00D9FF] to-[#00B8D4] text-[#0A0E27] font-semibold rounded-lg hover:shadow-lg hover:shadow-[#00D9FF]/30 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 text-sm"
              >
                {isSubmitting ? 'جاري الإرسال...' : 'اشترك الآن'}
              </button>
              {submitMessage && (
                <p className={`text-sm ${submitMessage.includes('نجاح') ? 'text-[#00FF94]' : 'text-red-400'}`}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>
        <div className="border-t border-[#00D9FF]/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 طيبات الطبية العالمية. جميع الحقوق محفوظة.
          </p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#00D9FF] text-sm transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
